function App() {
  // The website is served as static HTML directly from public/index.html.
  // React mounts into an empty (hidden) #root div and does not modify the DOM.
  return null;
}

export default App;
